export const BottomPadding = () => <div style={{ height: window.innerHeight * 0.3 }} />;
